import type { SceneContext } from '../_shared/types'
import type { VsData, VsStat } from './types'
import { vsHighlight } from './tick'

export default function VsComparison({ data, time }: SceneContext) {
  const d = data as unknown as VsData
  const hl = vsHighlight(data, time)
  const renderStats = (stats: VsStat[]) =>
    stats.map((s, i) => (
      <div className={`pv-vs-stat${i === hl ? ' pv-vs-stat-active' : ''}`} key={i}>
        <strong>{s.value}</strong>
        {s.label}
      </div>
    ))
  return (
    <div className="pv-vs" style={{ background: (data as any).bgColor }}>
      <div className="pv-vs-left">
        <div className="pv-vs-name">{d.left?.name}</div>
        {renderStats(d.left?.stats || [])}
      </div>
      <div className="pv-vs-divider">
        <span className="pv-vs-badge">VS</span>
      </div>
      <div className="pv-vs-right">
        <div className="pv-vs-name">{d.right?.name}</div>
        {renderStats(d.right?.stats || [])}
      </div>
    </div>
  )
}
